import { render } from "./AutomaticMessages.vue?vue&type=template&id=6983d07e"
import script from "./AutomaticMessages.vue?vue&type=script&lang=js"
export * from "./AutomaticMessages.vue?vue&type=script&lang=js"

import "./AutomaticMessages.vue?vue&type=style&index=0&id=6983d07e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__